// AppBreadcrumb.tsx
import { Breadcrumb } from 'antd';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components/macro';
import { ReactComponent as BreadcrumbIcon } from '../../images/Icon-breadcrumb-arrow.svg';

interface BreadCrumbItem {
    name: string;
    path: string;
}

interface AppBreadcrumbProps {
    breadcrumbs: BreadCrumbItem[];
}

export const BreadcrumbItem = styled(Breadcrumb.Item)<{ disabled?: boolean }>`
    /* Remove the color change on hover, only change cursor */
    &&& :hover {
        color: ${(props) => props.theme.styles['primary-color']};
        cursor: pointer;
    }
`;

const StyledButton = styled.button<{ disabled?: boolean }>`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: inherit;
    font-weight: normal;
    font-size: inherit;
    font-family: inherit;

    &:hover {
        color: inherit !important;
        background: none;
    }

    &:focus {
        outline: none;
        color: inherit;
    }
`;

const IS_BREADCRUMB_HIDDEN_PARAM = 'isBreadcrumbHidden';

export const AppBreadcrumb = ({ breadcrumbs }: AppBreadcrumbProps) => {
    const history = useHistory();
    const location = useLocation();

    // Check if breadcrumbs should be hidden based on URL parameter
    const searchParams = new URLSearchParams(location.search);
    const isFromSetting = searchParams.get(IS_BREADCRUMB_HIDDEN_PARAM);

    if (!breadcrumbs?.length || isFromSetting) {
        return null;
    }

    const handleClick = (item: BreadCrumbItem) => {
        history.push(item.path);
    };

    const isItemDisabled = (item: BreadCrumbItem, index: number) => {
        return !item.path || index === breadcrumbs.length - 1 || item.path === location.pathname;
    };

    return (
        <Breadcrumb className="f-page-breadcrumb" separator={<BreadcrumbIcon />}>
            {breadcrumbs.map((item, index) => (
                <BreadcrumbItem
                    key={JSON.stringify(item)}
                    className="f-breadcrumb-item"
                    disabled={isItemDisabled(item, index)}
                >
                    <StyledButton
                        type="button"
                        onClick={() => handleClick(item)}
                        disabled={isItemDisabled(item, index)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                handleClick(item);
                            }
                        }}
                    >
                        {item.name}
                    </StyledButton>
                </BreadcrumbItem>
            ))}
        </Breadcrumb>
    );
};
